import Vue from 'vue';
import App from './App';

//import Axios from 'axios'
import store from './store';

import router from './app-routes';

require('./public/style.css')

import moment from 'moment'

Vue.filter('formatDate', function(value) {
    if (value) {
      return moment(String(value)).format('DD.MM.YYYY')
    }
});
Vue.filter('formatDateTime', function(value) {
    if (value) {
      return moment(String(value)).format('DD.MM.YYYY HH:mm:ss')
    }
});
Vue.filter('formatCurrency', function (value) {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'code'
    });
    return formatter.format(value);
});
Vue.filter('trim', function(value) {
    if (value) {
      return value.replace(/\s/g,'')
    }
});

Vue.prototype.$status = {
	'Rechnung_valid-e-invoice_true': 'valide E-Rechnung',
  	'Rechnung_no-e-invoice_true': 'keine E-Rechnung',
  	'Rechnung_validation-failed_true': 'Valdierung fehlgeschlagen',
  	'Rechnung_invalid-e-invoice_true': 'invalide E-Rechnung'
}

Vue.prototype.$metaFields = {
	'olgv5:datenherkunft': 'Datenherkunft',
  	'olgv5:mandant': 'Mandant',
  	'cm:mimetype': 'MIME-Type',
  	'olgv5:belegtyp': 'Belegtyp',
  	'olgv5:untermandant': 'untermandant',
  	'cm:name': 'Dateiname',
  	'cm:size': 'Dateigröße',
  	'cm:created': 'Eingangsdatum',
  	'olgv5:statuslist': 'Validierungsstatus',
  	'olgv5:rechnungleistungsdatum': 'Rechnungleistungsdatum',
  	'olgv5:rechnungnettogesamt': 'Nettobetrag',
  	'olgv5:belegdatum': 'Belegdatum',
  	'olgv5:rechnungmehrwertsteuer1': 'Rechnungmehrwertsteuer1',
  	'olgv5:belegnummer': 'Belegnummer',
  	'olgv5:rechnungwaehrunggesamt': 'Währung',
  	'olgv5:rechnungmehrwertsteuergesamt': 'Mehrwertsteuer Gesamt',
  	'olgv5:rechnungbruttogesamt': 'Bruttobetrag',
  	'olgv5:rechnungnummer': 'Rechhnungsnummer',
  	'olgv5:rechnungdatum': 'Rechnungsdatum',
  	'olgv5:rechnungzahlbetrag': 'Rechnungzahlbetrag',
  	'olgv5:rechnungnetto1': 'Rechnungnetto1',
  	'olgv5:rechnungsteuersatz1': 'Rechnungsteuersatz1'
}

/**
 * Mount the Vue instance on the DOM element "#wp-vue-app" in the Custom Page Template
 */

new Vue({
	el: '#wp-vue-app',
	router,
	store,
	render: h => h( App )
});



// WEBPACK FOOTER //
// ./src/main.js